import {StyleProps} from '@mirohq-internal/website-types'

export type Outlines = {
  [key: string]: BaseTheme.StyleProps
}

export const createOutlineStyles = (
  options: BaseTheme.FocusOutline | BaseTheme.FocusOutlineWithOffset,
): StyleProps => {
  const {
    styles = {},
    borderRadius = 9,
    offset = {x: 0, y: 0},
  } = options as BaseTheme.FocusOutlineWithOffset
  return {
    ...styles,
    position: 'relative',
    '&:before': {
      borderRadius,
      borderColor: 'var(--wcds-btn-border-color-focus)',
      borderStyle: 'solid',
      borderWidth: 1,
      boxShadow:
        '0 0 0 3px var(--wcds-colors-focus-ring-default), 0 0 0 7px var(--wcds-btn-border-color-focus)',
      content: "''",
      position: 'absolute',
      top: offset.y,
      bottom: offset.y,
      left: offset.x,
      right: offset.x,
    },
  }
}

/**
 * Default focus outline styles
 */
export const outlines: Outlines = {
  default: createOutlineStyles({}),
  withOffset: createOutlineStyles({borderRadius: 4, offset: {x: -4, y: -4}}),
  withoutOffset: createOutlineStyles({borderRadius: 4, offset: {x: 0, y: 0}}),
  defaultOutline: createOutlineStyles({}),
}

export default {
  createOutlineStyles,
  outlines,
}
